@if (state === 'login') {
  <div class="login-page">
    <div class="login-card">
      <div class="login-card__logo">
        <img [src]="logo" alt="Logo" />
      </div>
      <div class="login-card__heading">
        <h1>{{ 'login.invite_welcome' | translate }}</h1>
        <p>{{ 'login.invite_subtitle' | translate }}</p>
      </div>
      <div class="login-card__actions">
        <button class="idp-btn" (click)="loginWithMicrosoft()">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 21 21">
            <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
            <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
            <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
            <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
          </svg>
          {{ 'login.microsoft' | translate }}
        </button>
        <button class="idp-btn" (click)="loginWithGoogle()">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 48 48">
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.18 1.48-4.97 2.31-8.16 2.31-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
            <path fill="none" d="M0 0h48v48H0z"/>
          </svg>
          {{ 'login.google' | translate }}
        </button>
        <button class="idp-btn" (click)="loginWithEmail()">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="2" y="4" width="20" height="16" rx="2"/>
            <path d="m22 7-10 6L2 7"/>
          </svg>
          {{ 'login.email' | translate }}
        </button>
      </div>
    </div>
  </div>
}

@if (state === 'processing') {
  <div class="login-page">
    <div class="login-card">
      <div class="login-card__logo">
        <img [src]="logo" alt="Logo" />
      </div>
      <p>{{ 'login.invite_processing' | translate }}</p>
    </div>
  </div>
}

@if (state === 'invite-used') {
  <div class="login-page">
    <div class="login-card">
      <div class="login-card__logo">
        <img [src]="logo" alt="Logo" />
      </div>
      <div class="login-card__heading">
        <h1>{{ 'login.invite_used_title' | translate }}</h1>
        <p>{{ 'login.invite_used_body' | translate }}</p>
      </div>
    </div>
  </div>
}

@if (state === 'error') {
  <div class="login-page">
    <div class="login-card">
      <div class="login-card__logo">
        <img [src]="logo" alt="Logo" />
      </div>
      <div class="login-card__heading">
        <h1>{{ 'login.invite_error_title' | translate }}</h1>
        <p>{{ 'login.invite_error_body' | translate }}</p>
      </div>
    </div>
  </div>
}
